module.exports = __webpack_public_path__ + "media/images/flags/4x3/mlt-55fb019dba39390c5e88ad731c13c788.svg";